import { render, staticRenderFns } from "./EbookContentWindow.vue?vue&type=template&id=2f5ac889&scoped=true&"
import script from "./EbookContentWindow.vue?vue&type=script&lang=js&"
export * from "./EbookContentWindow.vue?vue&type=script&lang=js&"
import style0 from "./EbookContentWindow.vue?vue&type=style&index=0&id=2f5ac889&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ac889",
  null
  
)

export default component.exports